/* mossriver-ga4-custom-events-v1
 * Standard page views and commerce events stay owned by Shopify's Google app.
 * This bridge only makes custom experiment events deliverable to GA4.
 */
(function () {
  'use strict';
  if (window.__mossriverGa4CustomEventsV1) return;
  window.__mossriverGa4CustomEventsV1 = true;
  window.dataLayer = window.dataLayer || [];
  var active = false;

  function analyticsAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) return true;
    if (typeof privacy.analyticsProcessingAllowed === 'function') {
      return privacy.analyticsProcessingAllowed();
    }
    if (typeof privacy.userCanBeTracked === 'function') {
      return privacy.userCanBeTracked();
    }
    return true;
  }

  window.gtag = window.gtag || function () {
    if (arguments[0] === 'event' && !active) return;
    window.dataLayer.push(arguments);
  };

  function start() {
    if (active || !analyticsAllowed()) return;
    active = true;
    if (!document.querySelector('script[data-mossriver-ga4-custom-events]')) {
      var tag = document.createElement('script');
      tag.async = true;
      tag.src = 'https://www.googletagmanager.com/gtag/js?id=G-8VWWZKPJQ7';
      tag.setAttribute('data-mossriver-ga4-custom-events', 'v1');
      document.head.appendChild(tag);
    }
    window.gtag('js', new Date());
    window.gtag('config', 'G-8VWWZKPJQ7', {send_page_view: false});
  }

  function loadPrivacyThenStart() {
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{name: 'consent-tracking-api', version: '0.1'}],
        function () { start(); }
      );
    } else {
      start();
    }
  }

  document.addEventListener('visitorConsentCollected', start, false);
  document.addEventListener('trackingConsentAccepted', start, false);
  loadPrivacyThenStart();
}());
